import React from 'react';

import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { captchaService } from 'services/CaptchaService';
import { Observable } from 'rxjs/Observable';
import { CAPTCHA_KEY } from 'settings';

const styles = require('./captcha.css');

interface IState extends IStateBase {
  show: boolean;
}

let scriptLoaded = false;

export default class Captcha extends BaseComponent<IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      show: false
    };
  }

  componentDidMount() {

    captchaService.getCaptchaStatus()
      .do(show => {
        this.setState({ show });
      })
      .filter(show => show)
      .switchMap(() => this.loadScript())
      .switchMap(() => {
        return Observable.of(true)
          .switchMap(() => {
            if (!grecaptcha.render) {
              return Observable.throw(new Error('captcha not loaded'));
            }
            return Observable.of(true);
          }).retryWhen(error$ => {
            console.log('waiting captcha load');
            return Observable.interval(100);
          });
      })
      .bindComponent(this)
      .subscribe(() => {
        setTimeout(() => {
          grecaptcha.render('recaptcha', {
            sitekey: CAPTCHA_KEY,
            callback: (token: string) => captchaService.setResult(token)
          });
        }, 100);
      });
  }

  loadScript(): Observable<boolean> {
    if (scriptLoaded) {
      return Observable.of(true);
    }

    return Observable.fromPromise(new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.onload = () => {
        console.log('script loaded');
        resolve();
      };

      script.setAttribute('src', '//www.google.com/recaptcha/api.js?render=explicit&onload=');
      document.body.appendChild(script);
      scriptLoaded = true;
    }));
  }

  render() {

    const { show } = this.state;

    if (!show) {
      return null;
    }

    return (
      <div className={styles.component}>
        <div className='captcha-container'>
          <div id='recaptcha' />
        </div>
      </div>);
  }

}


// WEBPACK FOOTER //
// ./src/components/Captcha/index.tsx